module.exports = __webpack_public_path__ + "img/plug.151478b7.svg";